import { PmPlanDTO, PmState } from '../../interfaces/maintenance';

export const PM_STATE_COLOR: Record<PmState, 'default' | 'success' | 'warning' | 'error'> = {
    OVERDUE: 'error', DUE_SOON: 'warning', OK: 'success', INACTIVE: 'default',
};

export const PM_STATE_LABEL: Record<PmState, string> = {
    OVERDUE: 'Overdue', DUE_SOON: 'Due soon', OK: 'On track', INACTIVE: 'Inactive',
};

const UNIT_WORD: Record<string, string> = { DAY: 'day', WEEK: 'week', MONTH: 'month' };

/** "Every 2 weeks / every 500 hours" -- human summary of a plan's trigger. */
export const pmTriggerText = (p: Pick<PmPlanDTO, 'trigger' | 'everyCount' | 'everyUnit' | 'everyMeter' | 'meterUnit'>): string => {
    const parts: string[] = [];
    if (p.trigger !== 'METER' && p.everyCount && p.everyUnit) {
        const w = UNIT_WORD[p.everyUnit] ?? p.everyUnit.toLowerCase();
        parts.push(`every ${p.everyCount} ${w}${p.everyCount > 1 ? 's' : ''}`);
    }
    if (p.trigger !== 'CALENDAR' && p.everyMeter) {
        parts.push(`every ${p.everyMeter} ${p.meterUnit ?? 'units'}`);
    }
    return parts.join(' or ');
};

/** Local calendar date (never toISOString, which is UTC). */
export const todayLocal = (): string => {
    const d = new Date();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${m}-${day}`;
};

/** Next-due cell: date and/or meter, whichever the plan has. */
export const pmNextDueText = (p: PmPlanDTO): string => {
    const parts: string[] = [];
    if (p.nextDueDate) parts.push(p.nextDueDate);
    if (p.nextDueMeter !== undefined && p.nextDueMeter !== null) parts.push(`${p.nextDueMeter} ${p.meterUnit ?? ''}`.trim());
    return parts.length ? parts.join(' / ') : '-';
};

export const pmDueHint = (p: PmPlanDTO): string => {
    if (p.state === 'INACTIVE') return '';
    const bits: string[] = [];
    if (p.daysUntilDue !== undefined && p.daysUntilDue !== null) {
        bits.push(p.daysUntilDue < 0 ? `${-p.daysUntilDue} d late` : p.daysUntilDue === 0 ? 'today' : `in ${p.daysUntilDue} d`);
    }
    if (p.meterRemaining !== undefined && p.meterRemaining !== null) {
        bits.push(p.meterRemaining < 0 ? `${-p.meterRemaining} ${p.meterUnit ?? ''} over` : `${p.meterRemaining} ${p.meterUnit ?? ''} left`);
    }
    return bits.join(', ');
};
